import { OverlayType } from './DefaultLayout';

type SettingsOption = Exclude<OverlayType, 'settings'> | 'report';

export const getSingleAvailableOption = ({
  displayNextUp,
  hasCaptions,
  canReportIssue,
  canDisplayQualities,
}: {
  displayNextUp: boolean;
  hasCaptions: boolean;
  canReportIssue: boolean;
  canDisplayQualities: boolean;
}): SettingsOption | undefined => {
  const availableSettingsOptions: SettingsOption[] = [
    ...(displayNextUp ? ['next-up' as const] : []),
    ...(hasCaptions ? ['captions' as const] : []),
    ...(canReportIssue ? ['report' as const] : []),
    ...(canDisplayQualities ? ['quality' as const] : []),
  ];

  return availableSettingsOptions.length === 1
    ? availableSettingsOptions[0]
    : undefined;
};
